import { render, staticRenderFns } from "./M_queue.vue?vue&type=template&id=22c16814&scoped=true&"
import script from "./M_queue.vue?vue&type=script&lang=js&"
export * from "./M_queue.vue?vue&type=script&lang=js&"
import style0 from "./M_queue.vue?vue&type=style&index=0&id=22c16814&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c16814",
  null
  
)

export default component.exports